import { createAsyncThunk } from '@reduxjs/toolkit';
import { getBoxIdFromThreadId } from './threadsV2Api';
export const getBoxId = createAsyncThunk('threads/getBoxId', async threadId => {
  const response = await getBoxIdFromThreadId(threadId);
  return response;
});